import React from "react";
import { Col } from "react-bootstrap";

export default function Challenge({challenge,toggleChallenges}) {

    return <Col xs={6} lg={6} xl={3}>
        <div className={`item ${challenge.selected ? '--isSelected' : ''} item-${challenge.id}`} onClick={() => toggleChallenges(challenge)}>
            <div>{challenge.name}</div>
        </div>
    </Col>;
}
